import PropTypes from 'prop-types'
import { Checkbox, RadioButton } from '@pretamanger/component-library'
import { SingleSelect } from './styles'

const Select = ({
  onChange,
  isSelected,
  sku,
  multiSelectable,
  type,
  label
}) => {
  const handleMultiSelectChange = e => {
    onChange(e.target.checked, sku)
  }
  const handleSingleSelectChange = () => {
    onChange(true, sku)
  }

  return multiSelectable ? (
    <Checkbox
      defaultChecked={isSelected}
      disabled={false}
      hideLabel
      label={label}
      id={`checkbox-${sku}`}
      isSelected={isSelected}
      name={sku}
      required={false}
      valid={false}
      onChange={handleMultiSelectChange}
    />
  ) : (
    <SingleSelect>
      <RadioButton
        name={type}
        defaultChecked={isSelected}
        value={sku}
        onChange={handleSingleSelectChange}
        id={`radiobutton-${sku}`}
        label={label}
      />
    </SingleSelect>
  )
}

Select.propTypes = {
  sku: PropTypes.string,
  label: PropTypes.string,
  multiSelectable: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired
}

Select.defaultProps = {
  label: '',
  sku: ''
}

export default Select
